// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { horizontalTriangleOutline16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-horizontal-triangle-outline': IconHorizontalTriangleOutline;
    }
}

/**
 * The icon component for the 'horizontalTriangleOutline' icon
 */
export class IconHorizontalTriangleOutline extends IconSvg {
    public constructor() {
        super(horizontalTriangleOutline16X16);
    }
}

registerIconSvg('icon-horizontal-triangle-outline', IconHorizontalTriangleOutline);
export const iconHorizontalTriangleOutlineTag = 'nimble-icon-horizontal-triangle-outline';
